import { createRouter } from '@tanstack/react-router'

import { rootRoute, authGateRoute, dashboardRoute, adminRoute, adminLayoutRoute } from './router/route-roots'
import { publicRoutes, indexRoute, dashboardRoutes, adminRoutes } from './router/route-definitions'

// Build the route tree
const routeTree = rootRoute.addChildren([
  ...publicRoutes,
  authGateRoute.addChildren([
    indexRoute,
    dashboardRoute.addChildren([
      ...dashboardRoutes,
      adminRoute.addChildren([
        adminLayoutRoute.addChildren(adminRoutes),
      ]),
    ]),
  ]),
])

export const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
